import { GetStaticPropsContext } from 'next'
import { FunctionComponent } from 'react'
import { PageParams, PreviewData } from '../@types/infrastructur'
import * as BookTrialLesson from '@/blocks/BookTrialLesson/Component'
import * as BookTrialLessonButton from '@/blocks/BookTrialLessonButton/Component'
import * as Box from '@/blocks/Box/Component'
import * as Catcher from '@/blocks/Catcher/Component'
import * as ContactForm from '@/blocks/ContactForm/Component'
import * as ContactLocal from '@/blocks/ContactLocal/Component'
import * as ContactWhatsapp from '@/blocks/ContactWhatsapp/Component'
import * as Content from '@/blocks/Content/Component'
import * as ContentFacts from '@/blocks/ContentFacts/Component'
import * as Courses from '@/blocks/Courses/Component'
import * as CtaBanner from '@/blocks/CtaBanner/Component'
import * as DefaultBlock from '@/blocks/DefaultBlock/Component'
import * as DrivingSchoolHeader from '@/blocks/DrivingSchoolHeader/Component'
import * as Faq from '@/blocks/Faq/Component'
import * as FlchBookTrialLesson from '@/blocks/FlchBookTrialLesson/Component'
import * as FlchContactLocal from '@/blocks/FlchContactLocal/Component'
import * as FlchContentWithImage from '@/blocks/FlchContentWithImage/Component'
import * as FlchCrosslinks from '@/blocks/FlchCrosslinks/Component'
import * as FlchFeatures from '@/blocks/FlchFeatures/Component'
import * as FlchHeader from '@/blocks/FlchHeader/Component'
import * as FlchLicenseCategories from '@/blocks/FlchLicenseCategories/Component'
import * as FlchLocations from '@/blocks/FlchLocations/Component'
import * as FlchPathToLicense from '@/blocks/FlchPathToLicense/Component'
import * as FlchReviews from '@/blocks/FlchReviews/Component'
import * as FlchTeacherShuffle from '@/blocks/FlchTeacherShuffle/Component'
import * as FlchTrialLessonCta from '@/blocks/FlchTrialLessonCta/Component'
import * as FreeTrialLessonHero from '@/blocks/FreeTrialLessonHero/Component'
import * as Gallery from '@/blocks/Gallery/Component'
import * as GalleryWide from '@/blocks/GalleryWide/Component'
import * as Guide from '@/blocks/Guide/Component'
import * as HeroBlob from '@/blocks/HeroBlob/Component'
import * as Icons from '@/blocks/Icons/Component'
import * as InteractiveMap from '@/blocks/InteractiveMap/Component'
import * as Jobs from '@/blocks/Jobs/Component'
import * as Lottery from '@/blocks/Lottery/Component'
import * as Magazine from '@/blocks/Magazine/Component'
import * as MagazineHero from '@/blocks/MagazineHero/Component'
import * as MeetupMap from '@/blocks/MeetupMap/Component'
import * as Mobiliar from '@/blocks/Mobiliar/Component'
import * as MyBlinkBenefits from '@/blocks/MyBlinkBenefits/Component'
import * as Offers from '@/blocks/Offers/Component'
import * as OfferTiles from '@/blocks/OfferTiles/Component'
import * as OtherLocations from '@/blocks/OtherLocations/Component'
import * as Packets from '@/blocks/Packets/Component'
import * as PartnersHero from '@/blocks/PartnersHero/Component'
import * as PriceCalculator from '@/blocks/PriceCalculator/Component'
import * as QuickLinks from '@/blocks/QuickLinks/Component'
import * as ShortLinks from '@/blocks/ShortLinks/Component'
import * as SliderHero from '@/blocks/SliderHero/Component'
import * as Story from '@/blocks/Story/Component'
import * as TcsForm from '@/blocks/TcsForm/Component'
import * as TcsWabCourses from '@/blocks/TcsWabCourses/Component'
import * as TeamAll from '@/blocks/TeamAll/Component'
import * as TeamSlider from '@/blocks/TeamSlider/Component'
import * as Testimonials from '@/blocks/Testimonials/Component'
import * as TestimonialsImage from '@/blocks/TestimonialsImage/Component'
import * as Tiles from '@/blocks/Tiles/Component'
import * as TrialLesson from '@/blocks/TrialLesson/Component'
import * as UpcomingFirstAidCourses from '@/blocks/UpcomingFirstAidCourses/Component'
import * as Video from '@/blocks/Video/Component'
import * as VideoHero from '@/blocks/VideoHero/Component'
import * as VideoSlider from '@/blocks/VideoSlider/Component'
import * as VoucherForm from '@/blocks/VoucherForm/Component'
import { ImageType } from '@/src/@types/statamic'

const blocks: Record<
  string,
  {
    getStaticProps?: (
      props: any,
      context: GetStaticPropsContext<PageParams, PreviewData>
    ) => any
    getTitle?: (props: any) => string | undefined
    getDescription?: (props: any) => string | undefined
    getImage?: (props: any) => ImageType | undefined
    default: FunctionComponent<any>
  }
> = {
  BookTrialLesson: BookTrialLesson,
  BookTrialLessonButton: BookTrialLessonButton,
  Box: Box,
  Catcher: Catcher,
  ContactForm: ContactForm,
  ContactLocal: ContactLocal,
  ContactWhatsapp: ContactWhatsapp,
  Content: Content,
  DefaultBlock: DefaultBlock,
  Gallery: Gallery,
  GalleryWide: GalleryWide,
  Guide: Guide,
  HeroBlob: HeroBlob,
  InteractiveMap: InteractiveMap,
  Jobs: Jobs,
  Magazine: Magazine,
  MagazineHero: MagazineHero,
  MeetupMap: MeetupMap,
  Packets: Packets,
  PartnersHero: PartnersHero,
  QuickLinks: QuickLinks,
  ShortLinks: ShortLinks,
  SliderHero: SliderHero,
  Story: Story,
  Testimonials: Testimonials,
  TestimonialsImage: TestimonialsImage,
  Tiles: Tiles,
  TrialLesson: TrialLesson,
  TeamAll: TeamAll,
  TeamSlider: TeamSlider,
  UpcomingFirstAidCourses: UpcomingFirstAidCourses,
  Video: Video,
  VideoHero: VideoHero,
  Courses: Courses,
  VoucherForm: VoucherForm,
  ContentFacts: ContentFacts,
  Icons: Icons,
  Mobiliar: Mobiliar,
  TcsForm: TcsForm,
  TcsWabCourses: TcsWabCourses,
  Faq: Faq,
  FreeTrialLessonHero: FreeTrialLessonHero,
  VideoSlider: VideoSlider,
  Lottery: Lottery,
  Offers: Offers,
  MyBlinkBenefits: MyBlinkBenefits,
  OfferTiles: OfferTiles,
  CtaBanner: CtaBanner,
  DrivingSchoolHeader: DrivingSchoolHeader,
  OtherLocations: OtherLocations,
  FlchHeader: FlchHeader,
  FlchBookTrialLesson: FlchBookTrialLesson,
  FlchTrialLessonCta: FlchTrialLessonCta,
  FlchCrosslinks: FlchCrosslinks,
  FlchContactLocal: FlchContactLocal,
  FlchContentWithImage: FlchContentWithImage,
  FlchTeacherShuffle: FlchTeacherShuffle,
  FlchFeatures: FlchFeatures,
  FlchReviews: FlchReviews,
  FlchLocations: FlchLocations,
  FlchLicenseCategories: FlchLicenseCategories,
  FlchPathToLicense: FlchPathToLicense,
  PriceCalculator: PriceCalculator,
}

export default blocks
